import useDevice from "@/hooks/useDevice";

type Props = {
  mobile?: boolean;
  desktop?: boolean;
};

export default function Platform({
  mobile,
  desktop,
  children,
}: React.PropsWithChildren<Props>) {
  const device = useDevice();

  if (device.isMobileOrTablet && mobile) {
    return children;
  }

  if (!device.isMobileOrTablet && desktop) {
    return children;
  }

  return null;
}
